import React from 'react';

/**
 * Inlined so the artwork renders with no network request - this modal is shown
 * precisely when the device is offline.
 */
const NoInternetIllustration = (props) => (
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_n_17435_88276)">
      <g clipPath="url(#clip0_17435_88276)">
        <rect width="160" height="160" rx="80" fill="#DEE2E6" />
        <rect
          x="63.9141"
          y="-20.8008"
          width="136.288"
          height="197.491"
          rx="16"
          transform="rotate(15 63.9141 -20.8008)"
          fill="#36393C"
        />
        <rect
          x="69.2188"
          y="-8.92383"
          width="119.883"
          height="177.931"
          rx="12"
          transform="rotate(15 69.2188 -8.92383)"
          fill="url(#paint0_linear_17435_88276)"
        />
        <path
          d="M86.5948 26.9915C88.1486 26.0945 90.1349 26.6267 91.0319 28.1805L136.973 107.753C137.87 109.307 137.338 111.294 135.784 112.191C134.231 113.087 132.244 112.555 131.347 111.002L119.005 89.6241C117.712 89.8493 116.358 89.2811 115.65 88.0848C113.92 85.1564 111.112 83.0228 107.826 82.1425C104.541 81.2622 101.042 81.7056 98.0796 83.3767C96.5173 84.2575 94.5363 83.7038 93.6548 82.1419C92.7734 80.5794 93.3245 78.5979 94.8866 77.7162C99.3303 75.2096 104.58 74.5463 109.508 75.8667C110.159 76.0411 110.797 76.2492 111.421 76.4876L105.059 65.4686C99.8351 65.3624 94.6673 66.6536 90.099 69.2308C88.5365 70.1121 86.5558 69.5582 85.6742 67.996C84.793 66.4335 85.3437 64.4519 86.906 63.5703C91.3745 61.0495 96.3134 59.5356 101.38 59.0966L96.1218 49.9892C91.8941 50.7778 87.7959 52.1619 83.9509 54.1046C82.3498 54.9135 80.3956 54.2701 79.5864 52.6691C78.7774 51.0679 79.4178 49.113 81.0189 48.3038C84.7351 46.426 88.6606 45.011 92.7054 44.0717L85.4059 31.4287C84.5089 29.875 85.0413 27.8887 86.5948 26.9915ZM105.335 91.5643C107.068 92.0286 108.096 93.8099 107.632 95.5429C107.167 97.2756 105.386 98.3043 103.653 97.84L103.623 97.8318C101.89 97.3675 100.861 95.586 101.325 93.8531C101.79 92.1201 103.571 91.0917 105.304 91.556L105.335 91.5643ZM125.117 69.4113C126.385 68.1417 128.44 68.1395 129.71 69.407C131.842 71.5357 133.698 73.9248 135.23 76.5188C136.142 78.0633 135.629 80.0549 134.084 80.9674C132.54 81.8796 130.547 81.3688 129.635 79.8244C128.381 77.7023 126.866 75.7455 125.122 74.004C123.852 72.7364 123.85 70.681 125.117 69.4113ZM113.554 43.5198C120.536 44.76 127.19 47.4164 133.107 51.324C139.024 55.2315 144.08 60.3073 147.962 66.2411C148.944 67.7425 148.521 69.7557 147.02 70.7378C145.518 71.7197 143.504 71.2998 142.522 69.7988C139.126 64.6069 134.703 60.1649 129.526 56.7459C124.349 53.3268 118.527 51.0038 112.418 49.9186C110.652 49.6047 109.475 47.916 109.789 46.1498C110.103 44.384 111.788 43.2063 113.554 43.5198Z"
          fill="#A6ADB5"
        />
        <g filter="url(#filter1_i_17435_88276)">
          <rect
            x="64.5312"
            y="121.119"
            width="63.0961"
            height="25.2385"
            rx="12"
            transform="rotate(15 64.5312 121.119)"
            fill="#3993FF"
          />
        </g>
        <g opacity="0.1" filter="url(#filter2_f_17435_88276)">
          <path
            d="M45.5474 174.941C37.917 179.109 21.3722 182.587 13.7831 162.808C6.74652 144.469 17.2916 135.932 32.1962 129.658C47.1007 123.384 55.7101 109.785 66.4885 109.474C77.267 109.164 82.5051 114.598 85.4087 121.442C91.6077 136.053 76.8434 154.588 68.1657 160.487C59.488 166.387 53.1777 170.774 45.5474 174.941Z"
            fill="black"
          />
        </g>
        <g filter="url(#filter3_n_17435_88276)">
          <path
            d="M33.3448 154.545C24.637 158.488 5.49068 161.293 -4.31125 140.492C-13.3997 121.204 -1.49797 112.885 15.6003 107.113C32.6986 101.34 42.0994 87.6976 54.6658 87.8906C67.2322 88.0836 73.6057 93.949 77.3216 101.16C85.2543 116.555 68.9047 135.005 59.057 140.687C49.2093 146.37 42.0526 150.602 33.3448 154.545Z"
            fill="url(#paint1_radial_17435_88276)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_n_17435_88276"
        x="0"
        y="0"
        width="160"
        height="160"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.5 12.5"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17435_88276">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_i_17435_88276"
        x="60.6953"
        y="123.812"
        width="62.0859"
        height="35.3223"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_17435_88276" />
      </filter>
      <filter
        id="filter2_f_17435_88276"
        x="5.55469"
        y="103.461"
        width="87.3281"
        height="80.707"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_17435_88276" />
      </filter>
      <filter
        id="filter3_n_17435_88276"
        x="-7.44531"
        y="87.8887"
        width="86.875"
        height="69.4277"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.5 12.5"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17435_88276">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <linearGradient
        id="paint0_linear_17435_88276"
        x1="94.1417"
        y1="-13.656"
        x2="210.87"
        y2="287.943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#D3E6FF" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_17435_88276"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.4667 101.015) rotate(58.1192) scale(62.2482 114.143)"
      >
        <stop stopColor="#7AA7AF" />
        <stop offset="0.3954" stopColor="#296A9B" />
        <stop offset="0.657194" stopColor="#1F3B63" />
        <stop offset="1" stopColor="#0E2435" />
      </radialGradient>
      <clipPath id="clip0_17435_88276">
        <rect width="160" height="160" rx="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NoInternetIllustration;
